import JsonSynchronizer from "./json_synchronizer.js"

function Parkour (params) {
    params = params || {}
    this.stepSignature       = params.stepSignature
    this.onStepReached       = params.onStepReached
    this.onStepCompleted     = params.onStepCompleted
    this.onLastStepCompleted = params.onLastStepCompleted

    if (params.synchronizer) {
        initSynchronizer(this, params.synchronizer)
    }

    this.doneSteps = {}
    defineDoneStepsCount(this)

    this.steps = []
    if (params.steps) {
        this.add(params.steps)
    }

    defineCurrent(this)
    definePrevious(this)
    defineNext(this)
    defineHighestDone(this)
    defineLowestNotDone(this)
}


Parkour.prototype.add = function (stepOrSteps) {
    if (Array.isArray(stepOrSteps)) {
        addSteps(this, stepOrSteps)
    } else {
        addStep(this, stepOrSteps)
    }
}


Parkour.prototype.goTo = function (stepSignature) {
    this.currentSignature = stepSignature
    saveCurrent(this, stepSignature)

    if (this.onStepReached) {
        this.onStepReached(this.current)
    }

    return this.current
}


Parkour.prototype.completeStep = function (step = this.current) {
    let stepSignature = getStepSignature(this, step)

    if (typeof stepSignature !== "undefined") {
        this.doneSteps[stepSignature] = true

        saveDoneStatus(this, stepSignature)

        if (this.onStepCompleted) {
            this.onStepCompleted(step)
        }

        if (this.isLastStep(step) && this.onLastStepCompleted) {
            this.onLastStepCompleted(step)
        }
    }
}


Parkour.prototype.isLastStep = function (step = this.current) {
    return this.getStepIndex(step) === this.steps.length - 1
}


Parkour.prototype.isCurrentStep = function (step) {
    return step === this.current
}


Parkour.prototype.getStepIndex = function (step) {
    return this.steps.indexOf(step)
}


Parkour.prototype.getStep = function (stepSignature) {
    return this.steps.find(step => stepSignature === getStepSignature(this, step))
}


Parkour.prototype.reset = function () {
    if (this.synchronizer) {
        this.synchronizer.clearLocal()
    }
    this.doneSteps = {}
    this.currentSignature = getStepSignature(this, this.steps[0])
}


Parkour.prototype.unlockAll = function () {

    this.steps.forEach((step) => {
        let stepSignature = getStepSignature(this, step)

        if (typeof stepSignature !== "undefined") {
            this.doneSteps[stepSignature] = true
            saveDoneStatus(this, stepSignature)
        }
    })

}


function defineCurrent (parkour) {
    Object.defineProperty(parkour, "current", {
        enumerable: true,
        get: function () {
            return parkour.getStep(parkour.currentSignature) || parkour.steps[0]
        }
    })
}


function definePrevious (parkour) {
    Object.defineProperty(parkour, "previous", {
        enumerable: true,
        get: function () {
            return getPreviousStep(parkour)
        }
    })
}


function getPreviousStep (parkour) {
    let currentIndex = parkour.getStepIndex(parkour.current)
    let previousIndex = currentIndex === -1 ? -1 : currentIndex - 1

    if (previousIndex >= 0) {
        return parkour.steps[previousIndex]
    } else {
        return null
    }
}


function defineNext (parkour) {
    Object.defineProperty(parkour, "next", {
        enumerable: true,
        get: function () {
            return getNextStep(parkour)
        }
    })
}


function getNextStep (parkour) {
    let currentIndex = parkour.getStepIndex(parkour.current)
    let nextIndex = currentIndex === -1 ? -1 : currentIndex + 1

    if (nextIndex !== -1 && nextIndex < parkour.steps.length) {
        return parkour.steps[nextIndex]
    } else {
        return null
    }
}


function defineHighestDone (parkour) {
    Object.defineProperty(parkour, "highestDone", {
        enumerable: true,
        get: function () {
            return getHighestStepDone(parkour)
        }
    })
}


function getHighestStepDone (parkour) {
    for (let i = parkour.steps.length - 1; i >= 0; i--) {
        let step      = parkour.steps[i]
        let signature = getStepSignature(parkour, step)
        if (parkour.doneSteps[signature]) {
            return step
        }
    }
    return null
}


function defineLowestNotDone (parkour) {
    Object.defineProperty(parkour, "lowestNotDone", {
        enumerable: true,
        get: () => getLowestStepNotDone(parkour)
    })
}


function getLowestStepNotDone (parkour) {
    return parkour.steps.find(step => {
        let signature = getStepSignature(parkour, step)
        return !parkour.doneSteps[signature]
    })
}


function saveCurrent (parkour, stepSignature) {
    storageSet(parkour, "current", stepSignature)
}


function getCurrentSignature (parkour) {
    let currentSignature = storageGet(parkour, "current")
    if (currentSignature) {
        return currentSignature
    } else if (parkour.steps.length > 0) {
        if (parkour.stepSignature) {
            return getStepSignature(parkour, parkour.steps[0])
        } else {
            return 0
        }
    } else {
        return undefined
    }
}


function getStepSignature (parkour, step) {
    let stepSignature

    if (parkour.stepSignature) {
        stepSignature = parkour.stepSignature(step)
    } else {
        let stepIndex = parkour.getStepIndex(step)
        if (stepIndex !== -1) {
            stepSignature = stepIndex
        }
    }

    return stepSignature
}


function addSteps (parkour, steps) {
    steps.forEach(step => addStep(parkour, step))
}


function addStep (parkour, step) {
    parkour.steps.push(step)
    fetchDoneStatusForStep(parkour, step)
    if (typeof parkour.currentSignature === "undefined") {
        parkour.currentSignature = getCurrentSignature(parkour)
    }
}


function saveDoneStatus (parkour, signature) {
    storageSet(parkour, `done_step_${signature}`, true)
}


function fetchDoneStatusForStep (parkour, step) {
    let stepSignature = getStepSignature(parkour, step)
    let done = Boolean(storageGet(parkour, `done_step_${stepSignature}`))

    if (done) {
        parkour.doneSteps[stepSignature] = true
    }
}


function defineDoneStepsCount (parkour) {
    Object.defineProperty(parkour, "doneStepsCount", {
        enumerable: true,
        get: function () {
            let doneStepsCount = 0
            for (let key in parkour.doneSteps) {
                if (parkour.doneSteps[key]) {
                    doneStepsCount += 1
                }
            }

            return doneStepsCount
        }
    })
}


function storageSet (parkour, key, value) {
    if (parkour.synchronizer) {
        parkour.synchronizer.updateKey(key, value)
    }
}


function storageGet (parkour, key) {
    return parkour.synchronizer ? parkour.synchronizer.getKey(key) : null
}


function initSynchronizer (parkour, synchronizerOrParams) {
    if (synchronizerOrParams instanceof JsonSynchronizer) {
        parkour.synchronizer = synchronizerOrParams
    } else {
        parkour.synchronizer = new JsonSynchronizer(synchronizerOrParams)
    }
}


export default Parkour

